namespace RecordShield.Workspace {

    @Serenity.Decorators.registerClass()
    export class ActivationsPickerDialog extends Serenity.TemplatedDialog<ProductPickerOptions> {
        protected getFormKey() { return ActivationsPickerForm.formKey; }
        private checkGrid: ActivationCheckGrid;
       
        constructor(opt: ProductPickerOptions) {
            super(opt);           
            this.checkGrid = new ActivationCheckGrid(this.byId("CheckGrid"), opt);
         
            this.dialogTitle = "Activations";
            
            
        }

        protected getTemplate() {
            return `<div id="~_CheckGrid"></div>`;
        }

        protected getDialogOptions() {
            var opt = super.getDialogOptions();
            opt.buttons = [
               
                {
                    text: Q.text("Dialogs.CancelButton"),
                    click: () => {
                        this.dialogClose();
                    }
                }
            ];
            return opt;
        }

        

       
    }
}